document.addEventListener("click", (e) => {
  const btn = e.target.closest("[data-tab-btn]");
  if (!btn) return;

  const root = btn.closest("[data-fc-tabs]");
  if (!root) return;

  const target = btn.getAttribute("data-tab-btn");

  root.querySelectorAll(".fc-tabs__btn").forEach((b) => {
    b.classList.toggle("is-active", b === btn);
    b.setAttribute("aria-selected", b === btn ? "true" : "false");
  });

  root.querySelectorAll(".fc-tabs__panel").forEach((p) => {
    p.classList.toggle("is-active", p.getAttribute("data-tab-panel") === target);
  });
});
